<div [class]="isVisible ? '' : 'hidden'">
    <app-shared-loading *ngIf="loading && isVisible"></app-shared-loading>
    <div class="general-title">
        <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
    </div>
    <app-return-methods [itsMobileCtrl]="true" [unique]="''" (RT)="changeMethod()"></app-return-methods>
    <div class="contentBox embebedApiPayInForm">
        <div class="col-3">
            <div class="info-logo-container">
                <img [src]="info?.logo ?? '' | safe" class="payment_method_no_interactive" alt="Digital payments" />
            </div>
        </div>
        <div class="col-7">
            <div class="methodInfo">
                <app-return-methods [itsMobileCtrl]="false" [unique]="''" (RT)="changeMethod()"></app-return-methods>
                <h1>{{ 'api-pay-in-payment-title' | translation | async }}</h1>
                <div class="iframeContainer">
                    <iframe id="apiPayInIframe" [src]="iframeUrl | safe" frameborder="0" width="100%" height="100%"></iframe>
                </div>
            </div>
        </div>
    </div>
</div>
